import { toBill, toCoins } from '../../../../../services/financial';

export function calculateSiteAmount(clientAmount, feePercentage, useCoinsConversion = false) {
  let convertedClientAmount = useCoinsConversion ? toCoins(clientAmount) : clientAmount;
  const siteAmount = Math.round(convertedClientAmount - (convertedClientAmount / 100) * feePercentage);
  return useCoinsConversion ? +toBill(siteAmount) : siteAmount;
}
